import styled from 'styled-components'
import { measurments } from '../utils/config'
import Logo from './Logo'

const StyledMinimalNav = styled.nav`
  background: transparent;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 10;
  .nav-inner {
    height: ${measurments.navHeight}px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: ${measurments.navWidth}px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`

const MinimalNav = () => {
  return (
    <StyledMinimalNav id='mainNav'>
      <div className='nav-inner'>
        <div className='nav-left'>
          <Logo />
        </div>
        <div />
      </div>
    </StyledMinimalNav>
  )
}

export default MinimalNav
